// extracted by mini-css-extract-plugin
export default {"header":"Header_header__mRVvh","headerWrapper":"Header_headerWrapper__JBjor"};